code

<template>
    <!--        <img alt="Vue logo" src="./assets/logo.png">-->
    <!--        <HelloWorld msg="Welcome to Your Vue.js App Abdullah"/>-->
    <div class="container">
        <div class="row fh-row justify-content-center">
            <div class="col-md-6 pl-0 pr-0 align-self-center">
                <mdb-card class="z-depth-1 card-height">
                  <mdb-card-header color="white">
                    <div class="container-fluid">
                      <div class="row">
                        <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                          <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                          <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                          <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                        </div>
                      </div>
                    </div>
                  </mdb-card-header>
                    <mdb-card-body class="text-center">
                      <div class="row">
                        <div class="col-12 align-self-center">
                          <mdb-progress class="mb-3" style="width: 100%; float:left"
                                        :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                            {{ $store.state.step }}/{{ $store.state.totalSteps }}
                          </mdb-progress>
                        </div>
                      </div>
                        <div class="container-fluid">
                            <div class="row hh-row">
                                <div class="col-12 align-self-center">
                                    <h4>Demo Video</h4>
                                    <img src="@/assets/animation.png" alt class="img-fluid"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p class>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </mdb-card-body>
                    <mdb-card-footer>
                      <div class="col-12 align-self-center">
                        <div class="row justify-content-center">
                          <div class="col-md-12 mb-1 mt-1">
                            <mdb-btn style="font-size: 15px" block color="primary" class="next-btn" size="md"
                                     @click="$router.push($store.state.configPath[$store.state.step])">
                              {{ $t("next") }}
                              <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                            </mdb-btn>
                          </div>
                        </div>
                      </div>
                    </mdb-card-footer>
                </mdb-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "About",
        components: {
            // HelloWorld,
        },
        mounted() {
          this.$store.commit('assignStep', this.$route.path)
        }
    };
</script>
<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

    $image-path: "~@/../mdb/mdbvue/img";
</style>
